import { useIsMutating } from '@tanstack/react-query';
import { mutationKeys } from '../api/mutation-keys';

/**
 * True while a calculation-preference change (date scope / cash buffer) is in flight. Such a change
 * recomputes the whole calculator, so every settings-drawer table shows the loading dim during it —
 * unlike a per-table toggle, which uses the separate `updateLiquiditySettings` mutation key and
 * therefore dims only its own table (via that table's own query `isFetching`).
 */
export const useLiquidityScopeUpdating = (): boolean => useIsMutating({ mutationKey: mutationKeys.updateLiquidityCalculatorCalculation() }) > 0;
